import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/Text';
import { fontSizes, spacing } from '@/constants/theme';

export type SocialSectionProps = {
  title: string;
  children: ReactNode;
  testID?: string;
};

/**
 * One section of the MarketPryce Social deal page (Figma "Apply" frame): a
 * bare Inter Bold title over its content. The Figma sets these sections
 * unboxed, unlike the reward deal page's SectionCards.
 */
export function SocialSection({ title, children, testID }: SocialSectionProps) {
  return (
    <View style={styles.section} testID={testID}>
      <Text variant="bodyBold" style={styles.title} accessibilityRole="header">
        {title}
      </Text>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    gap: spacing.md,
  },
  title: {
    fontSize: fontSizes.xl,
    lineHeight: 26,
  },
});
